<template>
  <BOverlay :show="isLoading">
    <BRow>
      <BCol cols="12" md="6">
        <CustomSelect
          class="w-100"
          v-model="newNotificationPayload.notificationType"
          inputId="notificationTypePicker"
          inputLabel="نوع ارسال"
          :customOptions="notificationTypeOptions"
          @getSelectedOption="setNotificationType"
        ></CustomSelect>
      </BCol>

      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="notificationTitle"
          inputLabel="عنوان نوتیفیکیشن"
          inputPlaceholder="اطلاعیه جدید"
          v-model="newNotificationPayload.subject"
        >
        </TextInput>
      </BCol>

      <BCol cols="12">
        <CustomEditor
          label="متن نوتیفیکیشن"
          v-model="newNotificationPayload.description"
        ></CustomEditor>
      </BCol>

      <BCol cols="6">
        <BFormGroup
          label="آیا برای تمام کاربران ارسال شود؟"
          label-for="allUsers"
        >
          <BFormCheckbox
            id="allUsers"
            v-model="newNotificationPayload.allusers"
            :value="true"
            switch
          >
          </BFormCheckbox>
        </BFormGroup>
      </BCol>

      <BCol cols="12" md="6" v-if="!newNotificationPayload.allusers">
        <UserPicker multiple @getUser="setUserIds"></UserPicker>
      </BCol>

      <BCol cols="12" class="mt-3">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <BButton variant="success" @click="askForConfirmation"> ثبت </BButton>
        </div>
      </BCol>
    </BRow>

    <SendToAllConfirmationDialog @sendNotification="sendNewNotification">
    </SendToAllConfirmationDialog>
  </BOverlay>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      newNotificationPayload: {
        senderId: null,
        subject: null,
        description: null,
        allusers: true,
        reciverIds: [],
        notificationType: 0,
        isFromSystem: false,
      },
      notificationTypeOptions: [
        {
          value: 0,
          text: "نوتیفیکیشن سیستمی",
        },
        {
          value: 1,
          text: "اس ام اس",
        },
        {
          value: 2,
          text: "ایمیل",
        },
      ],
    };
  },
  methods: {
    setNotificationType(notificationType) {
      this.newNotificationPayload.notificationType = notificationType;
    },
    askForConfirmation() {
      // Text Message
      if (
        this.newNotificationPayload.allusers == true ||
        this.newNotificationPayload.allusers == "true"
      ) {
        this.$bvModal.show("send-notif-to-all-confirmation-dialog");
      } else {
        this.sendNewNotification();
      }
    },
    setUserIds(usersList) {
      let userIds = [];
      usersList.forEach((item) => {
        userIds.push(item.userId);
      });
      this.newNotificationPayload.reciverIds = userIds;
    },
    async getUserByToken() {
      return new Promise(async (resolve, reject) => {
        try {
          let _this = this;
          let getUserByToken = new GetUserByToken(_this);
          await getUserByToken.fetch((res) => {
            let userDetails = {
              user: res.data,
            };

            userDetails["role"] = this.userData.user.role;
            userDetails["userRoleAccesses"] =
              this.userData.user.userRoleAccesses;
            userDetails["token"] = this.userData.token;
            userDetails["refreshToken"] = this.userData.refreshToken;
            userDetails["ability"] = this.userData.ability;
            resolve(userDetails);
          });
          window.dispatchEvent(
            new CustomEvent("unreadCount-localstorage-changed")
          );
        } catch (error) {
          console.error(error);
          reject(error);
        }
      });
    },
    async sendNewNotification() {
      try {
        this.$nextTick(() => {
          this.$bvModal.hide("send-notif-to-all-confirmation-dialog");
        });
        // Text Message
        if (this.newNotificationPayload.notificationType == 1) {
          let span = document.createElement("span");
          span.innerHTML = this.newNotificationPayload.description;
          this.newNotificationPayload.description =
            span.textContent || span.innerText;
        }
        const userData = getUserData();
        if (userData && userData.user && userData.user.userId) {
          this.newNotificationPayload.senderId = userData.user.userId;
        }
        this.isLoading = true;
        let _this = this;
        let sendNotification = new SendNotification(_this);
        sendNotification.setRequestParamDataObj(_this.newNotificationPayload);
        await sendNotification.fetch(async (response) => {
          if (response.isSuccess) {
            const userData = await this.getUserByToken();
            this.$nextTick(() => {
              localStorage.removeItem("userData");
              localStorage.setItem("userData", JSON.stringify(userData));
            });
            _this.getUserByToken();
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "نوتیفیکیشن با موفقیت ارسال شد.",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.newNotificationPayload = {
              senderId: null,
              subject: null,
              description: null,
              allusers: true,
              reciverIds: [],
              notificationType: 0,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  response.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید.",
                icon: "XIcon",
                variant: "danger",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    userData() {
      if (getUserData) {
        return getUserData();
      }
    },
  },
  components: {
    SendToAllConfirmationDialog,
    CustomCreateDialog,
    BFormCheckbox,
    CustomEditor,
    CustomSelect,
    BFormGroup,
    UserPicker,
    TextInput,
    BOverlay,
    BButton,
    BRow,
    BCol,
  },
};
import SendToAllConfirmationDialog from "@/views/components/Notifications/SendToAllConfirmationDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import CustomEditor from "@/views/components/Utils/CustomEditor.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import {
  BFormCheckbox,
  BFormGroup,
  BOverlay,
  BButton,
  BRow,
  BCol,
} from "bootstrap-vue";
import { SendNotification } from "@/libs/Api/Notifications";
import { getUserData } from "@/auth/utils";
import { GetUserByToken } from "@/libs/Api/Users";
</script>
